"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TYPES_COLOR = void 0;
var TYPES_COLOR = {
  instantConfirm: "background: #EAF1FF; color: #1E63E8;",
  freeCancellation: "background: #D4F2E0; color: #067834;",
  notToConfirmAtOnce: "background: inherit; color: #B65800; padding: 0px;",
  nothindRefund: "background-color: #E6E9EE;\n    color: #4D4D4D;",
  partialRefund: "background-color: #DCF0C8;\n    color: #4D4D4D;",
  earlyBooking: "background-color: #ece8f1;\n    color: #4b137b;",
  crown: "background-image: linear-gradient(to right, #d1b094, #decda1);\n    color: #160c0d;",
  rareConfirmation: "background-color: #f4e1ba;\n    color: #d0021b;",
  advantages: "\n    background-color: #f7efe6;\n    color: #804d55;\n    ",
  fewChance: "\n    background-color: #f9eaec;\n    color: #d0021b;\n    ",
  filterPenalized: "\n    text-decoration-line: line-through;\n    background-color: #E6E9EE;\n    color: #919499;\n    ",
  "default": ""
};
exports.TYPES_COLOR = TYPES_COLOR;